/**
 * Convert an address object into a google map link
 */
export default function fmAddressBox($parse) {
  'ngInject';
  return {
    restrict: 'E',
    replace: true,
    template: require('./address_box.html'),
    link: function (scope, element, attrs) {
      // parse address expression
      let address = $parse(attrs.address)(scope);
      // assign variables to scope
      scope.label = attrs.label;
      scope.location = address.recapito;
      scope.contacts = address.contatto;
      // function to create a maps address
      scope.getAddressURL = function(location) {
        let fullAddress = location.indirizzo + ', ' + location.comune;
        return `http://maps.google.com?q=${encodeURI(fullAddress)}`;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/directives/address_box.js